<div fxLayout="column" fxLayoutGap="8px" data-testid="module-config-field-formula-autocomplete">
    @if (loading()) {
        <ngx-skeleton-loader
            count="1"
            role="status"
            [attr.aria-busy]="true"
            [attr.aria-label]="'a11y.moduleConfig.loadingFormula' | translate"
            [theme]="{ width: '100%', height: '56px', margin: '0' }" />
    } @else {
        <mat-form-field appearance="outline" class="formula-autocomplete" subscriptSizing="dynamic">
            <mat-label>{{ "modules.fieldConfig.formula.expression" | translate }}</mat-label>
            <mat-chip-grid
                #chipGrid
                [disabled]="locked()"
                [attr.aria-label]="'modules.fieldConfig.formula.expression' | translate">
                @for (token of tokens(); track $index; let index = $index) {
                    <mat-chip-row
                        data-testid="module-config-field-formula-autocomplete-chip"
                        [class.operator]="isSymbol(token)"
                        [class.formula-chip--error]="invalidIndexes().has(index)"
                        (removed)="remove(index)"
                        (click)="resume(index)">
                        {{ chipText(token) }}
                        <button matChipRemove [attr.aria-label]="'actions.delete' | translate">
                            <mat-icon aria-hidden="true">cancel</mat-icon>
                        </button>
                    </mat-chip-row>
                }
                <input
                    #input
                    data-testid="module-config-field-formula-autocomplete-input"
                    [placeholder]="placeholder().key | translate: placeholder().params"
                    [matChipInputFor]="chipGrid"
                    [matAutocomplete]="auto"
                    [value]="query()"
                    (input)="onInput(input)"
                    (keydown)="onKeydown($event)" />
            </mat-chip-grid>
            <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption (optionSelected)="choose($event)">
                @for (group of groups(); track group.label) {
                    <mat-optgroup [label]="group.label | translate">
                        @for (item of group.items; track item.id) {
                            <mat-option
                                data-testid="module-config-field-formula-autocomplete-option"
                                [attr.data-option-id]="item.id"
                                [value]="item">
                                <span fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
                                    <span>{{ item.label }}</span>
                                    @if (item.hint) {
                                        <span class="mat-caption cipo-text--black-500">{{ item.hint }}</span>
                                    }
                                </span>
                            </mat-option>
                        }
                    </mat-optgroup>
                }
            </mat-autocomplete>
        </mat-form-field>

        <cipo-formula-status [tokens]="tokens()" [isDateResult]="isDateResult()" />
    }

    @if (disabled()) {
        <span class="mat-caption cipo-text--black-500" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px">
            <mat-icon class="material-icons-outlined" inline aria-hidden="true">info</mat-icon>
            {{ "modules.fieldConfig.formula.onlyOnDefault" | translate }}
        </span>
    }
</div>
